import { lazy } from 'react';

const HostPartnerEarningsSection = lazy(() => import('../HostPartnerEarnings'));

const HostPartnerEarningsSectionLazy = () => {
  return <HostPartnerEarningsSection />;
};

export default HostPartnerEarningsSectionLazy; 